import { LogLevel } from '@nts/std/src/lib/utility';

export const environment = {
  production: true,
  baseAppUrl: 'https://ntsscheduleservice.ntsinformatica.it',
  authenticationAppUrl: 'https://ntsloginservice.ntsinformatica.it/auth/login',
  prefixApi: '/api',
  envType: 'DEV',
  appTitle: 'ScheduleService - DEV',
  appSubTitle: '',
  logLevel: LogLevel.All,
  isEnterpriseBarrierRequired: false
};
